<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin, BTable,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { avatarText } from '@core/utils/filter';

export default {
  components: {
    BTable,
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        representanteid: '',
        representantenome: '',
      }),
      require: true,
    },

  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  setup() {
    return {
      // Filter
      avatarText,
    };
  },
};
</script>

<template>
  <validation-observer ref="refFormData">
    <b-form @submit.prevent>
      <b-row>
        <b-col
            cols="6"
            class="mb-0"
        >
          <b-form-group
              label="Representante"
              label-for="representantenome"
          >
            <validation-provider
                #default="{ errors }"
                name="Descrição"
                rules="required"
            >
              <b-form-input
                  v-model="dataForm.representante.representantenome"
                  id="representantenome"
                  :state="errors.length > 0 ? false : null"
                  placeholder="representantenome"
                  disabled
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>

  </validation-observer>

</template>
